/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54134918
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Accordion from '@components/@core/Accordion';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import EditDropdown from '@components/EditDropdown';
import { RecurringType, LibraryToDoHabitDetailMenu } from '~/services/config';
import { getSettings } from '~/services/util';

const Detail = ({ authors, departments, competencies, categories, data, userRole, onSelect }) => {
    if (isNil(data)) return null;

    const departmentIds = data.data.department || [];
    const competencyIds = data.data.competency || [];
    const categoryIds = data.data.category || [];
    const schedule = data.data.schedule_interval;

    return (
        <>
            <Filter back="all habits" />
            <div className="lib-todo-habit">
                <div className="habit-detail">
                    <div className="d-flex jc-between py-2">
                        <p className="dsl-b22 bold">{data.name}</p>
                        <EditDropdown options={LibraryToDoHabitDetailMenu[userRole]} onChange={onSelect} />
                    </div>
                    <div>
                        <p className="dsl-m12 mb-2">Description</p>
                        <p className="dsl-b16 p-2">{data.data.description || data.description}</p>
                    </div>
                    <div className="my-2">
                        <p className="dsl-m12 mb-0">Frequency</p>
                        <div className="p-2">
                            <p className="dsl-b16 mb-0 text-400">{RecurringType[schedule]?.label}&nbsp;</p>
                        </div>
                    </div>

                    <Accordion className="settings-habit" icon="fas fa-gear">
                        <Row className="mt-1">
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Author" direction="vertical" value={getSettings([data.author_id], authors, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Categories" direction="vertical" value={getSettings(categoryIds, categories, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Competencies" direction="vertical" value={getSettings(competencyIds, competencies, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Departments" direction="vertical" value={getSettings(departmentIds, departments, 'N/A')} />
                            </Col>
                        </Row>
                    </Accordion>
                </div>
            </div>
        </>
    );
};

Detail.propTypes = {
    tags: PropTypes.array,
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        data: PropTypes.any,
        author_id: PropTypes.number,
    }),
};

Detail.defaultProps = {
    tags: [],
    data: {
        id: 0,
        name: '',
        data: {},
        author_id: 0,
    },
};

export default memo(Detail);
